import React from "react";
const ContactMain = () => {
  return (
    <>

      {/* ================= Contact Main start =================*/}
      <div className='contact-area pd-bottom-120' style={{ paddingTop: '50px' }}>
        <div className='container'>
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className='contact-page-list' style={{ marginBottom: '0' }}>
                <div className='container'>
                  <div className='row justify-content-center'>
                    <div className='col-12'>
                      <div className='media single-contact-list'>
                        <div className='media-left'>
                          <img src='assets/img/icon/13.svg' alt='img' />
                        </div>
                        <div className='media-body'>
                          <h5>Contacts us</h5>
                          <h6>+91 9265073148</h6>
                        </div>
                      </div>
                    </div>
                    <div className='col-12'>
                      <div className='media single-contact-list'>
                        <div className='media-left'>
                          <img src='assets/img/icon/14.svg' alt='img' />
                        </div>
                        <div className='media-body'>
                          <h5>Your Email</h5>
                          <h6>info@krishnasteelforge.com</h6>
                          <h6>marketing@krishnasteelforge.com</h6>
                        </div>
                      </div>
                    </div>
                    <div className='col-12'>
                      <div className='media single-contact-list'>
                        <div className='media-left'>
                          <img src='assets/img/icon/15.svg' alt='img' />
                        </div>
                        <div className='media-body'>
                          <h5>Location</h5>
                          <h6 style={{color: `#246BFD`, fontSize: `18px`}}><b>Krishna Steel Forge</b></h6>
                          <h6>Caption Gate, Survey No. 267, Plot No. 12 A/B, Near Caption Poly Plast, SHAPAR(VERAVAL) Dist. Rajkot. 360024.</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className='contact-g-map'>
                <iframe src='https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2920.3883827791083!2d70.7835960752886!3d22.16449357978447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjLCsDA5JzUyLjIiTiA3MMKwNDcnMTAuMiJF!5e1!3m2!1sen!2sin!4v1740679159532!5m2!1sen!2sin' title="g-map location" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactMain;
